import React from 'react';

interface Props {
	score: number;
}

const MeetingCardScoreComponent = ({ score }: Props) => {
	return (
		<div className="px-3 py-2 bg-[#E5F0FF] rounded-[12px] w-max border border-solid border-[#73DFE7] min-w-[56px]">
			<div className="text-xl font-semibold text-[#7777E7] text-center">{Math.round(score)}</div>
			<div className="text-[10px] font-normal text-[#555770] text-center mt-1">Score</div>
		</div>
	);
};

export default MeetingCardScoreComponent;
